// extracted by mini-css-extract-plugin
module.exports = {"container":"BrandProducts_container__KLx_m","title":"BrandProducts_title__Y9suE","titleDescription":"BrandProducts_titleDescription__CNiwl","list":"BrandProducts_list__Ljv09"};
module.exports.__checksum = "de5c23c4f6df"
